import { RESET_STATE } from 'store/global/actions';

import { LEAD_POOL_CRITERIA_SCHEMA_ACTION_TYPE } from '../actions';

const initialState = {};

const leadPoolCriteriaSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LEAD_POOL_CRITERIA_SCHEMA_ACTION_TYPE.GET_SCHEMA:
      return payload || state;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default leadPoolCriteriaSchemaReducer;
